import * as React from 'react'
import { QueryResult } from '@apollo/client'
import { Query } from '@apollo/client/react/components'
import { client } from '../utils/GQLClient'
import { DocumentNode } from 'graphql'
import { OperationVariables } from '@apollo/client'

interface Props<TRes, TVars> {
  variables: TVars
  children(
    r: QueryResult<
      TRes,
      TVars extends OperationVariables ? TVars : OperationVariables
    >
  ): JSX.Element | null
  fetchPolicy?:
    | 'cache-first'
    | 'cache-only'
    | 'cache-and-network'
    | 'network-only'
    | 'no-cache'
    | 'standby'
}

export abstract class BaseQuery<R, V> extends React.Component<Props<R, V>> {
  protected abstract query: DocumentNode
  render() {
    const { variables, children, fetchPolicy } = this.props
    return (
      <Query<R>
        client={client}
        query={this.query}
        variables={variables as any}
        fetchPolicy={fetchPolicy}
      >
        {children as any}
      </Query>
    )
  }
}
